import { GroupHeadingProps, components } from "react-select";

import styles from "./select-layout.module.scss";

const GroupHeading = (props: GroupHeadingProps) => (
  <components.GroupHeading {...props} id={styles.group_heading} />
);

export default GroupHeading;
